import { TFunction } from 'next-i18next';
import { TFullImageWithHeading } from '@features/cms/typescript';
import { BASE_PATH } from '@config/index';
const getFullImageWithHeadingDataDIP = (t: TFunction): TFullImageWithHeading => ({
  backgroundImage: {
    desktop: ``,
    tablet: ``,
    mobile: ``
  },
  description: t('shoowroomInfoDip.description'),
  buttonText: t('shoowroomInfoDip.button'),
  buttonUrl: '/drzwi',
  thumbnail: '',
  title: t('shoowroomInfoDip.title'),
  subtitle: undefined,
  video: {
    desktop: `${BASE_PATH}/videos/salon/SpotHeroSalonyL.mp4`,
    tablet: `${BASE_PATH}/videos/salon/SpotHeroSalonyM.mp4`,
    mobile: `${BASE_PATH}/videos/salon/SpotHeroSalonyS.mp4`
  },
  variant: 'default',
  variantContent: 'center',
  contentWidth: 'small'
});
export default getFullImageWithHeadingDataDIP;